import React, { useEffect, useRef } from 'react'
import {
  Title,
  SpacingVertical,
  Tooltip,
  ToastContainer,
  ModalConfirm
} from 'mailup-web-components'
import PageContainer from 'Components/PageContainer'
import Header from './components/Header'
import ErrorFeedback from 'Components/ErrorFeedback'
import { useRecoilCallback, useRecoilValue, useResetRecoilState } from 'recoil'
import { modalConfirmState, pageState } from './recoil/states/page'
import {
  cancelScheduleCallback,
  deleteScheduleCallback,
  deleteSendingCallback,
  initCallback,
  reloadScheduledSendingsCallback,
  resetCallback,
  stopSendingCallback
} from './recoil/callbacks/callbacks'
import { useIntl } from 'react-intl'
import styled from '@emotion/styled'
import SendList from './components/SendList'
import ModalSchedule from './components/ModalSchedule'

const RcsSendStatus = () => {
  const intl = useIntl()
  const resetState = useRecoilCallback(resetCallback, [])
  const init = useRecoilCallback(initCallback, [])
  const reloadScheduledSendings = useRecoilCallback(
    reloadScheduledSendingsCallback,
    []
  )
  const { error, severity } = useRecoilValue(pageState)
  const {
    action,
    idSending,
    idSchedule,
    modalConfirmShow,
    modalConfirmTitle,
    modalConfirmMessage,
    modalCofirmActionString,
    modalConfirmCancelString,
    modalConfirmVariant
  } = useRecoilValue(modalConfirmState)
  const resetModalConfirm = useResetRecoilState(modalConfirmState)
  const cancelSchedule = useRecoilCallback(cancelScheduleCallback, [])
  const deleteSending = useRecoilCallback(deleteSendingCallback, [])
  const stopSending = useRecoilCallback(stopSendingCallback, [])

  const RELOAD_INTERVAL = 15 * 1000 //  15s
  const timer = useRef(true)

  useEffect(() => {
    init()
    timer.current = setInterval(reloadScheduledSendings, RELOAD_INTERVAL)

    return () => {
      clearInterval(timer.current)
      resetState()
    }
  }, [])

  const onClickModalConfirm = () => {
    if (action === 'delete') {
      deleteSending(idSending)
    }
    if (action === 'cancelSchedule') {
      cancelSchedule(idSchedule)
    }
    if (action === 'stop') {
      stopSending(idSchedule)
    }
  }

  const onClickModalConfirmCancel = () => {
    resetModalConfirm()
  }

  return (
    <>
      <Header />
      <Tooltip />
      <ToastContainer />
      <ModalSchedule />
      <ModalConfirm
        show={modalConfirmShow}
        title={modalConfirmTitle}
        message={modalConfirmMessage}
        stringConfirm={modalCofirmActionString}
        stringCancel={modalConfirmCancelString}
        variant={modalConfirmVariant}
        onClickConfirm={onClickModalConfirm}
        onClickCancel={onClickModalConfirmCancel}
        closeOnOverlayClick
        showClose
      />
      <PageContainer className='c-RcsSendStatus'>
        <ErrorFeedback
          error={error}
          severity={severity}
          // onClickReload={() => init()}
        />
        {!error && (
          <>
            <StyledTitle variant='L'>
              {intl.formatMessage({
                id: 'Load.Rcs.SendStatusTitle'
              })}
            </StyledTitle>

            <SpacingVertical />
            <SendList />
          </>
        )}
      </PageContainer>
    </>
  )
}

export default RcsSendStatus

const StyledTitle = styled(Title)`
  text-align: center;
`
